import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser } from "../../lib/api";
import { ReferralTree } from "../../components/ReferralTree";

export default function AdminReferralTree() {
  const user = readUser();
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/referral-tree").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  // Group users by sponsor and build a forest; show synthetic "Platform" root.
  const map = {};
  users.forEach((u) => { map[u.id] = { ...u, children: [] }; });
  const roots = [];
  users.forEach((u) => {
    if (u.sponsor_id && map[u.sponsor_id]) map[u.sponsor_id].children.push(map[u.id]);
    else roots.push(map[u.id]);
  });
  const platform = { id: "platform", name: "Platform", level: 0, children: roots };
  return (
    <AdminLayout user={user} active="Referans Ağacı">
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">GENEL AĞAÇ</span><h2>Platform Referans Ağacı ({users.length} üye)</h2></div></div>
        <ReferralTree root={platform} />
      </section>
    </AdminLayout>
  );
}
